import ScrapExecution from '@/models/ScrapExecution/ScrapExecution';

export default class ScrapExecutionFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.scrapExecutionNumber = '';
		this.customerId = '';
		this.customerCode = '';
		this.vendorScrapId = '';
		this.vendorScrapCode = '';
		this.scrapExecutionDateFrom = '';
		this.scrapExecutionDateTo = '';
		this.beratScrap = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			scrapExecutionNumber: '0',
			customerId: '0',
			customerCode: '0',
			vendorScrapId: '0',
			vendorScrapCode: '0',
			scrapExecutionDateFrom: '0',
			scrapExecutionDateTo: '0',
			beratScrap: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}